import Hls from 'hls.js';
import Plyr from 'plyr';

const players = Plyr.setup('.plyr');

export class Video {
    constructor(videoEl) {
        videoEl.forEach(video => {
            let srcHls = video.getAttribute('data-src-hls');
            let autoplay = video.getAttribute('data-autoplay') || video.getAttribute('data-autoplay') === '' ? true : false;

            if (Hls.isSupported() && srcHls) {
                let hlsVideo = new Hls({
                    startLevel: 3,
                    minAutoBitrate: 1135000,
                });
                hlsVideo.loadSource(srcHls);
                hlsVideo.attachMedia(video);
                hlsVideo.on(Hls.Events.MANIFEST_PARSED, () => {
                    if(autoplay) {
                        video.play();
                    }
                });
                hlsVideo.on(Hls.Events.LEVEL_SWITCHING,  (event, data) => hlsVideo.nextLoadLevel = data.level);

            } else {
                if(autoplay) {
                    video.play();
                }
            }
        });
     }
}



// WEBPACK FOOTER //
// ./resources/js/frontend/video.js